<template>
<div class="SystemSetting">
    <keep-alive :include="includeList">
        <router-view :hostroletype="hostroletype"></router-view>
    </keep-alive>
</div>
</template>

<script>
export default {
    name: 'SystemSetting',
    data() {
        return {
            hostroletype: 2,
            includeList: ['goodsList', 'addrList']
        }
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.SystemSetting {
}
</style>
